module.exports = __webpack_public_path__ + "img/primary-logo-siu-white.95fa0b98.png";